/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'network-profile';

export const NetworkProfileModalBreadcrumbTitle = `${prefix}.NetworkProfileModalBreadcrumbTitle`;

export const ENGLISH = {
    [NetworkProfileModalBreadcrumbTitle]: 'Network Profile',
};
